export default __webpack_public_path__ + "static/media/7.278f5323.jpg";